import { ScreenResolutionInfo } from "../screen";
import { sleep } from "../../../../util/util";

export interface CheckResult {
  info: string;
  status?: boolean;
}

export const getScreenResolution = async (
  width: number,
  height: number,
  minScreenResolution: ScreenResolutionInfo,
) => {
  await sleep();
  const info = `${width} x ${height}`;
  const isCompatible =
    width >= minScreenResolution.width && height >= minScreenResolution.height;
  return {
    info: info,
    status: isCompatible,
  };
};
